<template>
  <div class="columns">
    <div class="column">
      <div class="has-text-centered">
        <h1 class="title is-1">3</h1>
        <p class="subtitle">Seasons</p>
      </div>
    </div>
    <div class="column">
      <div class="has-text-centered">
        <h1 class="title is-1">25</h1>
        <p class="subtitle">Rooms</p>          
      </div>
    </div>
<!--     <div class="column">
      <div class="has-text-centered">
        <h1 class="title is-1">2k</h1>
        <p class="subtitle">products</p>          
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'Analytics',

    props: ['city'],

    created() {
      // console.log(this.city);
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Analytics/Analytics.vue